import styled from 'styled-components';
const percentageSize = 1.3;

export const ModalContainer = styled.div`
  width: 100%;
  padding: 20px;
`;

export const CloseBtnWrapper = styled.button`
  background: none;
  border: none;
`;
export const Background = styled.div`
  z-index: 30;
  /* position: absolute;
  width: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); */
  background-color: transparent;
  border-radius: 10px;
`;

export const Header = styled.div`
  width: 100%;
  height: 30px;
  display: flex;
  background-color: #333333;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  justify-content: space-between;
  align-items: center;
  padding-left: 30px;
  /* box-shadow: 0 4px 7px -2px #252525; */
`;

export const BlobWrapper = styled.div`
  width: 100%;
`;

export const Title = styled.div`
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 16 * percentageSize : 16)}px;

  opacity: ${({ disabled }) => (disabled ? '40%' : '100%')};
  color: white;
`;

export const Content = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const InputWrapper = styled.div`
  margin-top: 10px;
`;
export const NameText = styled.div`
  color: white;
  opacity: ${({ disabled }) => (disabled ? '40%' : '100%')};
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 14 * percentageSize : 14)}px;
  margin-right: 10px;
`;

export const NameInput = styled.input`
  width: 100%;
  opacity: ${({ disabled }) => (disabled ? '40%' : '100%')};

  color: white;
  background-color: transparent;
  border: none;
  border-bottom: 1px solid;
  border-color: white;
  padding-left: 5px;
  padding-bottom: 5px;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 14 * percentageSize : 14)}px;
  &:focus {
    outline: none;
  }
  ::placeholder,
  ::-webkit-input-placeholder {
    color: #aaaaaa;
  }
  :-ms-input-placeholder {
    color: #aaaaaa;
  }
`;

export const Footer = styled.div`
  margin-top: 20px;
  width: 100%;
  display: flex;
  align-items: center;
`;

export const Checkbox = styled.input`
  opacity: ${({ disabled }) => (disabled ? '40%' : '100%')};
  cursor: pointer;
  appearance: none;
  font: inherit;
  color: white;
  width: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 16 * percentageSize : 16)}px;
  height: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 16 * percentageSize : 16)}px;
  margin-right: 3px;
  border: 0.13em solid white;
  border-radius: 0.15em;
  display: grid;
  place-content: center;
  display: inline-block;
  position: relative;

  :hover {
    box-shadow: 0 0px 7px #febf00dd;
  }

  :checked {
    position: relative;
    width: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 16 * percentageSize : 16)}px;
    height: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 16 * percentageSize : 16)}px;
    background-image: url(${({ img }) => img});
    background-repeat: no-repeat;
    background-size: contain;
    border-radius: 0.15em;
    transition: 0.3s;
  }
`;

export const GenerarButton = styled.button`
  opacity: ${({ disabled }) => (disabled ? '40%' : '100%')};
  background-color: #666666;
  color: white;
  border-radius: 10px;
  width: ${({ disabled }) => (disabled ? '40%' : '100%')};
  height: 32px;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 14 * percentageSize : 14)}px;
  margin-top: 10px;
  border: 1px solid #666666;
  :hover {
    box-shadow: 0 0px 7px #febf00dd;
  }
`;
export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 5px;
`;
export const CloseSVG = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  viewBox: '0 0 24 24',
  width: 30,
  height: 30,
  fill: '#fff'
}))``;

export const DeleteInput = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  viewBox: '0 0 24 24',
  width: props.fontSizeEnabled ? 30 * percentageSize : 30,
  height: props.fontSizeEnabled ? 30 * percentageSize : 30,
  fill: '#fff'
}))`
  position: absolute;
  right: 20px;
  opacity: ${({ disabled }) => (disabled ? '40%' : '100%')};
  width: 20px;
  cursor: pointer;
`;
